import { render, staticRenderFns } from "./PriceCheck.vue?vue&type=template&id=49c46c27&scoped=true"
import script from "./PriceCheck.vue?vue&type=script&lang=ts"
export * from "./PriceCheck.vue?vue&type=script&lang=ts"
import style0 from "./PriceCheck.vue?vue&type=style&index=0&id=49c46c27&prod&scoped=true&lang=css"
import style1 from "./PriceCheck.vue?vue&type=style&index=1&id=49c46c27&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c46c27",
  null
  
)

export default component.exports